/**
 * Slug helpers for the path-based uploader.
 *
 *   https://host/smith-jones          -> "smith-jones"
 *   https://host/smith-jones/gallery   -> "smith-jones"
 *   http://localhost:3000              -> reads REACT_APP_DEV_SLUG
 *
 * The site slug is the first path segment. For local dev, set
 * REACT_APP_DEV_SLUG=<slug> in .env.local so the app can resolve a real
 * site without a path prefix (the dev server serves at the root).
 */

/**
 * Returns the first path segment of the current URL, or "" when at the
 * root. Used for the React Router `basename` so deep links such as
 * `/smith-jones/gallery` resolve correctly.
 */
export function readSlugFromPath(): string {
  const segment = window.location.pathname.split("/").filter(Boolean)[0];
  return segment ?? "";
}

/**
 * Resolves the site slug used to load presentation config. Prefers the
 * `REACT_APP_DEV_SLUG` override on localhost, otherwise the first path
 * segment. Throws when no slug can be determined (e.g. the bare root in
 * production) so the caller can render the "missing" screen.
 */
export function readSlug(): string {
  const host = window.location.hostname;
  const devOverride = process.env.REACT_APP_DEV_SLUG;
  if (devOverride && (host === "localhost" || host === "127.0.0.1")) {
    return devOverride;
  }
  const segment = readSlugFromPath();
  if (!segment) throw new Error("Unable to determine slug from path.");
  return segment;
}

